export interface TableOptions {
  head: boolean;
  foot: boolean;
  delete: boolean;
  archive: boolean;
  download: boolean;
  add: boolean;
  search: boolean;
  filter: boolean;
  selectable: boolean;
  type: (typeof TABLE_TYPES)[number];
  map: boolean;
  tile: boolean;
  pageSize: number;
  layout: TableContentPart["layout"] | null;
  totalRows?: number;
}

export const TABLE_TYPES = ["DEFAULT", "PICKLIST", "SERVER_SIDE"] as const;

export interface TableResponse {
  canarchive: boolean;
  candelete: string;
  candownload: string;
  type: string;
  dtocontentpart: TableContentPart;
}

export interface TableContentPart {
  candelete: string;
  candownload: string;
  nrofresults?: number;
  contentid: string;
  data: TableResponseData;
  foot: string;
  head: string;
  groupfilters: {
    level: string;
    filters: TableContentPartFilter[];
  }[];
  headerfields: TableResponseHeader[];
  id: string;
  index: number;
  modal: boolean;
  searchfilter: { filter: string }[];
  setsearchfiltersaction: string;
  setstatusaction: string;
  setcolumnsortaction: string;
  status: string;
  title: string;
  type: string;
  tabletype?: number;
  buttons: TableResponseButton[];
  layout?: {
    list_columns: string[];
    tile_columns: string[];
    map_columns: {
      pin: string | null;
      popup: string[];
    };
  };
  wp: string;
}

export interface TableContentPartFilter {
  active: string;
  groupid: string;
  level: string;
  leveldesc: string;
  value: string;
}

export interface TableResponseGroup {
  groupid: string;
  groups: TableResponseGroup[];
  id: string;
  level: string;
  rowcount: string;
  rows: TableResponseRow[];
  totalrowcount: string;
  value: string;
}

export interface TableResponseButton {
  description: string;
  ffwdaction: string;
  id: string;
  snapshottypes: { description: string; ffwdaction: string; id: string }[];
  dlname: string;
}

export interface TableButton {
  data: unknown;
  templateId: string;
}

export interface TableResponseField {
  a: TableResponseAttachmentLink[];
  group: string;
  pfx: string;
  ffipe: string;
  tt: { tooltip: string; value: string }[];
  value: unknown;
  l: {
    icon?: string;
    link: string;
    value: unknown;
  }[];
}

export interface TableResponseAttachmentLink {
  description: string;
  link: string;
  omsExtensie: string;
  pa2Bestandsnaam: string;
  padOriginalFilename: string;
}

export interface TableResponseData {
  groups: TableResponseGroup[];
  rows: TableResponseRow[];
}

export interface TableResponseRow {
  deletelink: string;
  downloadlink: string;
  fields: TableResponseField[];
}

export interface TableResponseHeader {
  group: string;
  headericon: string;
  intablesearch: string;
  orgname?: string;
  name: string;
  pfx: string;
  width: string;
  sortorder: string;
  sortcolumn: string;
  hidecolumn: string;
}
